import { Pagination } from '../BaseModel'
import { WalletCoin } from '../coin/models'

export interface CreateWalletDTO {
  accountName: string
  accountType: WalletType
}

export interface GetWalletListDTO {
  /**
   * 钱包类型，1：资产钱包，2：web3钱包，空：全部类型
   */
  accountType?: WalletType
  name?: string
  pageSize?: number
  pageNumber: number
  hiddenStatus?: number
}

export interface GetVaultAccountDetailDTO {
  accountKey: string
}
export interface SetAccountHiddenStatusDTO {
  accountKey: string
  hiddenStatus: number
}
export type GetWeb3VaultAccountDetailDTO = GetVaultAccountDetailDTO

export type WalletPaginationModel = Pagination<WalletItemModel>

export enum WalletType {
  all = '',
  asset = 1,
  web3 = 2,
}

export interface WalletAssetsModel {
  balanceUsd: string
  openUsdBalance: string
  visibleTypeBalanceList: { accountVisibleType: 0 | 1; balanceUsd: string }[]
}

export interface WalletPlainItemModel {
  accountIndex: number
  accountKey: string
  accountName: string
  accountType: WalletType
  createSource: number
  workspaceKey: string
  usdBalance: string
  id: string
}

export interface WalletItemModel extends WalletPlainItemModel {
  amlLockUsdBalance: string
  frozenUsdBalance: string
  usdBalance: string
  openUsdBalance: string
  openapiUtxoStatus: number
  coinList: WalletCoin[]
  addressList?: { address: string }[]
}

export interface PubKey {
  signAlg: string
  pubkey: string
}

export interface Web3Address {
  blockchainType: string
  address: string
}

export interface Web3WalletItemModel {
  id: string
  workspaceKey: string
  accountKey: string
  accountIndex: string
  accountName: string
  hiddenOnConsole: number
  platform: number
  accountType: number
  pubkeyList: PubKey[]
  addressList: Web3Address[]
}
